<template>
  <div>
    <div
      v-if="accommodatie"
      class="flex flex-col m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 bg-gray-100 p-3"
    >
      <div class="flex flex-col lg:flex-row xl:flew-row">
        <div
          class="flex-grow order-2 sm:order-2 md:order-2 lg:order-1 xl:order-1"
        >
          <p
            class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase"
            v-if="!hasPermission('update accommodatie')"
          >
            {{ accommodatie.naam }}
          </p>
          <input
            type="text"
            v-else
            class="font-raleway font-bold text-2xl text-mi-blue-500 bg-gray-100 border-b border-gray-500 border-dashed w-3/4"
            v-model="accommodatie.naam"
          />
          <p
            class="font-opensans capitalize"
            v-if="!hasPermission('update accommodatie')"
          >
            {{ accommodatie.straat }}, {{ accommodatie.postcode }},
            {{ accommodatie.plaats["naam"] }}
          </p>
          <p class="font-opensans -mb-2" v-else>
            <input
              type="text"
              class="font-opensans bg-gray-100 border-b border-gray-500 border-dashed"
              v-model="accommodatie.straat"
            />
            <input
              type="text"
              class="font-opensans bg-gray-100 border-b border-gray-500 border-dashed"
              size="6"
              v-model="accommodatie.postcode"
              v-on:blur="getPc"
            />
            {{ accommodatie.plaats["naam"] }}
            <button
              class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold py-1 px-2 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent mt-1"
              @click="submitHandler"
            >
              Opslaan
            </button>

            <span class="text-red-600 ml-2">{{ msg }}</span>
          </p>
        </div>
        <BackToSearch
          class="flex-grow-0 order-1 sm:order-1 md:order-1 lg:order-2 xl:order-2"
        />
      </div>

      <Map
        :currentAccommodatieLatLon="accommodatie.latlon"
        :accommodatiesInDistance="accommodatiesInDistance"
      />
      <div class="mb-2">
        <button
          class="bg-gray-100  text-blue-700 font-semibold py-1 px-2 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent mt-1"
          @click="submitVerification"
          v-if="hasPermission('update accommodatie')"
        >
          Check gedaan
        </button>
      </div>
      <div
        class="font-raleway font-semibold text-xl text-mi-blue-500 uppercase mt-4"
      >
        Eigenschappen
      </div>
      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 grid-flow-row gap-4"
      >
        <MainPropertiesCard :acc="accommodatie" />
        <ExternalDataCard :acc="accommodatie" />
      </div>

      <div>
        <hr class="border-gray-300 border" />
      </div>

      <div
        class="font-raleway font-semibold text-xl mt-4 text-mi-blue-500 uppercase"
      >
        Opmerkingen
      </div>
      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4"
      >
        <FeedbackFormCard
          :objectid="this.$route.params.id"
          v-if="hasPermission('create comment')"
        />
      </div>

      <div
        class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4"
      >
        <FeedbackList
          :objectid="this.$route.params.id"
          v-if="hasPermission('read todoitem')"
        />
      </div>
    </div>
    <div
      v-else
      class="flex m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 p-3"
    >
      <div class="m-auto">
        <img src="../../assets/logo.svg" class="w-64 pl-8 mt-32" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FeedbackFormCard from "./FeedbackFormCard";
import FeedbackList from "./FeedbackList";
import Map from "./Map";
import MainPropertiesCard from "./MainPropertiesCard";
import ExternalDataCard from "./ExternalDataCard";
import BackToSearch from "./BackToSearch";

export default {
  name: "AccommodatieHome",
  components: {
    FeedbackFormCard,
    FeedbackList,
    Map,
    MainPropertiesCard,
    ExternalDataCard,
    BackToSearch
  },
  data() {
    return {
      msg: null,
      accommodatiesInDistance: null
    };
  },
  created: function() {
    this.loadAccommodatie(this.$route.params.id);
  },
  mounted: async function() {
    this.accommodatiesInDistance = await this.loadAccommodatiesInDistance(
      this.$route.params.id
    );
  },
  computed: mapState({
    accommodatie: function(state) {
      // we addded a check on presence of the current_accommodatie object otherwise computed just does not run further
      // not sure why
      if (!state.backend_data.current_accommodatie) return null;
      if (
        this.$route.params.id !== state.backend_data.current_accommodatie.id
      ) {
        return null;
      }
      return state.backend_data.current_accommodatie;
    }
  }),
  methods: {
    ...mapActions(["loadAccommodatie", "loadAccommodatiesInDistance"]),
    getPc: async function() {
      const plaats = await this.$store.dispatch(
        "getPlaatsByPostcode",
        this.accommodatie["postcode"]
      );
      this.accommodatie.plaats["naam"] = plaats["naam"];
      this.accommodatie.plaats["id"] = plaats["id"];
    },
    hideMsg: function() {
      this.msg = null;
    },

    submitHandler: async function() {
      await this.getPc();
      const updatedAccommodatie = {
        naam: this.accommodatie.naam,
        postcode: this.accommodatie.postcode,
        straat: this.accommodatie.straat,
        plaats: {
          naam: this.accommodatie.plaats.naam,
          id: this.accommodatie.plaats.id,
          code: this.accommodatie.plaats.code
        }
      };
      const [ok, msg] = await this.$store.dispatch(
        "updateAccommodatie",
        updatedAccommodatie
      );
      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
      } else {
        this.msg = msg;
      }
    },
    submitVerification: async function() {
      const [ok, msg] = await this.$store.dispatch(
        "addVerification",
        this.accommodatie.id
      );
      if (ok) {
        this.msg = "Verificatie succesvol opgeslagen";
      } else {
        this.msg = msg;
      }
    }
  },
  watch: {
    msg() {
      if (this.msg) {
        setTimeout(this.hideMsg, 5000);
      }
    },
    async $route() {
      this.loadAccommodatie(this.$route.params.id);
      this.accommodatiesInDistance = await this.loadAccommodatiesInDistance(
        this.$route.params.id
      );
    }
  }
};
</script>
